import React from 'react';
import './RoomModal.css';

const RoomModal = ({ children, onClose }) => {
    return (
        <div className="room-modal-overlay" onClick={onClose}>
            <div className="room-modal-content" onClick={e => e.stopPropagation()}>
                {children}
            </div>
        </div>
    );
};

export default RoomModal;
